import styled from 'styled-components'
import EliteBadgeWhiteTransparent from 'images/EliteBadgeWhiteTransparent.png'

export const EliteImage = styled.img.attrs({
	src: EliteBadgeWhiteTransparent,
})`
	height: 30px;
    display: block;
    margin: auto;
`
